import React, { useCallback, useEffect, useState } from 'react';
import { Eye, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { api, eur, errMsg } from '../api';
import { usePortal } from '../PortalAuth';
import { ghostBtn, goldBtn } from '../ui';
import NegativeDetails from '../negativita/NegativeDetails';

const FLAGS = [['protesti', 'Protesti'], ['pregiudizievoli', 'Pregiudizievoli'], ['procedure', 'Procedure concorsuali'], ['coinvoltoInProcedura', 'Coinvolto in procedure']];

export default function SubjectNegative({ checkId, idx }) {
  const { refresh } = usePortal();
  const [n, setN] = useState(null);
  const [price, setPrice] = useState(null);
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const base = `/aml/checks/${checkId}/subjects/${idx}/negative`;
  const load = useCallback(() => api.get(base).then((r) => setN(r.data)).catch(() => {}), [base]);
  useEffect(() => { load(); api.get('/cs/prices').then((r) => setPrice(r.data.negative_details?.cents)).catch(() => {}); }, [load]);
  useEffect(() => {
    if (n?.status !== 'pending') return undefined;
    const t = setInterval(load, 8000);
    return () => clearInterval(t);
  }, [n?.status, load]);
  if (!n) return null;
  const openDetails = async () => {
    if (n.details) { setOpen((o) => !o); return; }
    if (!window.confirm(`Aprire il dettaglio delle negatività di ${n.name}?${price ? ` Costo ${eur(price)}.` : ''}`)) return;
    setBusy(true);
    try { setN((await api.post(`${base}/details`)).data); setOpen(true); refresh(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const label = n.status === 'pending' ? 'IN CORSO' : n.status === 'error' ? 'NON ESEGUITA' : n.positive ? 'POSITIVO' : 'NEGATIVO';
  const cls = n.status === 'done' ? (n.positive ? 'text-[#E37A72] border-[#E37A72]/40 bg-[#E37A72]/[0.06]' : 'text-[#5FBF8E] border-[#5FBF8E]/40 bg-[#5FBF8E]/[0.06]') : 'text-[#D4AF37] border-[#5A4A17]';
  return (
    <div className="border-b border-[#1F242C] last:border-0 py-3" data-testid={`aml-negative-${idx}`}>
      <div className="flex flex-wrap items-center gap-3">
        <span className="flex-1 text-sm text-[#C9CCD1]">Negatività (protesti, pregiudizievoli, procedure)<span className="block text-xs text-[#5A5F67]">Inclusa nel reputational check</span></span>
        {n.status === 'pending' && <Loader2 size={13} className="animate-spin text-[#D4AF37]" />}
        <span className={`text-[10px] font-mono tracking-wider px-2 py-1 border rounded-sm ${cls}`} data-testid={`aml-negative-${idx}-status`}>{label}</span>
        {n.status === 'done' && n.positive && (
          <button onClick={openDetails} disabled={busy} className={`${n.details ? ghostBtn : goldBtn} h-8 px-3 inline-flex items-center gap-2 text-xs`} data-testid={`aml-negative-${idx}-details-btn`}>
            {busy ? <Loader2 size={13} className="animate-spin" /> : <Eye size={13} />}
            {n.details ? (open ? 'Chiudi dettaglio' : 'Vedi dettaglio') : `Chiedi dettaglio${price ? ` · ${eur(price)}` : ''}`}
          </button>
        )}
      </div>
      {n.status === 'done' && n.positive && (
        <div className="flex flex-wrap gap-2 mt-2">
          {FLAGS.filter(([k]) => n.flags?.[k]).map(([k, l]) => <span key={k} className="text-[11px] px-2 py-0.5 border rounded-sm border-[#5A2420] text-[#E37A72]">{l}</span>)}
        </div>
      )}
      {open && n.details && <NegativeDetails d={n.details} id={`aml-${idx}`} />}
    </div>
  );
}
